import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { validateData, postOrPutRequest, getOrDeleteRequest, customSwal, encryptData, sanitize, getSession } from '../../../utils/utils.js';
import SelectMultiple from '../../../components/SelectMultiple.jsx';
import Skeleton from 'react-loading-skeleton';
import Input from '../../../components/Input.jsx';
import MainThemeLayout from '../../../layout/MainThemeLayout.jsx';
import InputFile from '../../../components/inputFile.jsx';
import FormError from '../../../components/FormError.jsx';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import PrevButton from '../../../components/PrevButton.jsx';
import UserAvatar from '../../../images/icon.png';

const AddEditEmployee = () => {
    const [formulario, setFormulario] = useState({
        company_id: getSession().company.id,
        names: '',
        lastnames: '',
        email: '',
        password: '',
        password_confirmation: '',
        phone: '',
        charge: '',
        credential: '',
        photo: '',
    });

    const [formularioEditar, setFormularioEditar] = useState({
        company_id: getSession().company.id,
        names: '',
        lastnames: '',
        email: '',
        phone: '',
        charge: '',
        credential: '',
        photo: '',
        status: ''
    });

    const [alert, setAlert] = useState([{
        inputName: "",
        status: false,
        message: ""
    }]);

    const [fileName, setFileName] = useState(null);

    const handleFile = (e) => {
        let file = e.target.files[0];
        if (file) {
            // console.log(file);
            setFileName(file.name);
            setFormulario({ ...formulario, photo: file });
        }
    };

    const { id } = useParams();

    const [loading, setLoading] = useState(true);
    // const [userTypes, setUserTypes] = useState([{ name: "admin", id: 1 }]);

    const navigate = useNavigate();

    const getData = async (id) => {
        let response = await getOrDeleteRequest(
            `employees/find/${id}`,
            'GET',
        );
        // console.log(response);
        // return;
        if (response.type === 'success') {
            if (response.data) {
                setFormularioEditar({
                    names: response.data.user?.personal_data.names,
                    lastnames: response.data.user?.personal_data.lastnames,
                    email: response.data.user?.email,
                    phone: response.data.phone,
                    charge: response.data.charge,
                    credential: response.data.credential,
                    photo: response.data.photo,
                    status: response.data.status,
                });
            } else {
                Swal.fire({
                    title: '¡Error!',
                    text: 'No se encontraron datos sobre este usuario',
                    icon: 'error',
                    confirmButtonText: 'Aceptar',
                }).then(() => {
                    navigate('/Empleados');
                });
            }
        } else {
            Swal.fire({
                title: '¡Error!',
                text: response.message,
                icon: 'error',
                confirmButtonText: 'Aceptar',
            });
        }
    };

    const sendData = async () => {

        let photo = formulario.photo;
        // Limpiar informacion
        let data = sanitize(id ? formularioEditar : formulario);

        if (!id) {
            data.password = encryptData(data.password);
            data.password_confirmation = encryptData(data.password_confirmation);
        }

        data.photo = photo;
        // console.log(data);
        // Consulta a la API
        let response = await postOrPutRequest(
            id ? `employees/update/${id}?_method=PUT` : `employees/create`,
            'POST',
            {
                ...data,
                email: encryptData(data.email),
            }
        );

        // en vez de register seria create
        if (response.type === 'success') {
            Swal.fire({
                title: '¡Éxito!',
                text: response.message,
                icon: 'success',
                confirmButtonText: 'Aceptar',
                timer: 3000
            }).then(() => {
                navigate('/Empleados');
            });
        } else {
            Swal.fire({
                title: '¡Error!',
                text: response.message,
                icon: 'error',
                confirmButtonText: 'Aceptar',
            });
        }
    };

    const validateDataForm = (e) => {
        e.preventDefault();
        let inputs = Object.entries(id ? formularioEditar : formulario).map(([key, value]) => {
            return {
                name: key,
                value: value,
            };
        });

        const datosValidados = validateData(inputs);
        setAlert(datosValidados);
        let totalValidaciones = datosValidados.filter((input) => input.status !== false).map(() => { return false });

        if (totalValidaciones.length === 0) {
            if (id === undefined && formulario.password !== formulario.password_confirmation) {
                Swal.fire({
                    title: '¡Error!',
                    text: 'Las contraseñas no coinciden',
                    icon: 'error',
                    confirmButtonText: 'Aceptar',
                });
            } else {
                Swal.fire({
                    title: 'Cargando...',
                    text: 'Por favor espere',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
                sendData();
            }
        }
    };

    const allFunctions = async () => {
        setLoading(true);

        if (id) {
            await getData(id);
        }

        setLoading(false);
    }

    useEffect(() => {
        allFunctions();
    }, []);

    return (
        <MainThemeLayout>
            <div className="flex flex-col gap-4 p-4">
                <div className="">
                        <Link to={"/Empleados"}>
                            <PrevButton />
                        </Link>
                    <h1 className="bg-white dark:bg-[#292929] dark:text-turquesa px-2 py-10 text-center text-2xl font-semibold rounded-lg text-turquesa">

                            {id === undefined ? 'Agregar' : 'Actualizar'} Empleado
                    </h1>
                </div>
                <div className=" bg-white dark:bg-[#292929] shadow-default p-5 rounded-lg">
                    <form onSubmit={validateDataForm}>
                        <div className="p-6.5">
                            <div className="mb-4.5 flex flex-col gap-6 md:flex-row">
                                <div className="w-full md:w-1/2 mb-4">
                                    <Input
                                        label='Nombres'
                                        type='text'
                                        value={id ? formularioEditar.names : formulario.names}
                                        name='names'
                                        placeholder='Ingrese los nombres'
                                        loading={loading}
                                        required={true}
                                        onChange={(e) => {
                                            id ? setFormularioEditar({ ...formularioEditar, names: e.target.value })
                                                : setFormulario({ ...formulario, names: e.target.value })
                                        }}
                                        alert={alert}

                                    />
                                </div>

                                <div className="w-full md:w-1/2">
                                    <Input
                                        label='Apellidos'
                                        type='text'
                                        value={id ? formularioEditar.lastnames : formulario.lastnames}
                                        name='lastnames'
                                        placeholder='Ingrese los apellidos'
                                        loading={loading}
                                        required={true}
                                        onChange={(e) => {
                                            id ? setFormularioEditar({ ...formularioEditar, lastnames: e.target.value })
                                                : setFormulario({ ...formulario, lastnames: e.target.value })
                                        }}
                                        alert={alert}
                                    />
                                </div>
                            </div>

                            <div className="mb-4.5 flex flex-col gap-6 md:flex-row">
                                <div className="w-full md:w-1/2 mb-4">
                                    <Input
                                        label='Correo electrónico'
                                        type='text'
                                        value={id ? formularioEditar.email : formulario.email}
                                        name='email'
                                        placeholder='Ingrese el correo electrónico'
                                        loading={loading}
                                        required={true}
                                        onChange={(e) => {
                                            id ? setFormularioEditar({ ...formularioEditar, email: e.target.value })
                                                : setFormulario({ ...formulario, email: e.target.value })
                                        }}
                                        alert={alert}
                                    />
                                </div>

                                <div className="w-full md:w-1/2">
                                    <Input
                                        label='Número de teléfono'
                                        type='text'
                                        value={id ? formularioEditar.phone : formulario.phone}
                                        name='phone'
                                        placeholder='0000-0000'
                                        loading={loading}
                                        mask="9999-9999"
                                        required={true}
                                        onChange={(e) => {
                                            id ? setFormularioEditar({ ...formularioEditar, phone: e.target.value })
                                                : setFormulario({ ...formulario, phone: e.target.value })
                                        }}
                                        alert={alert}
                                    />
                                </div>
                            </div>

                            <div className="mb-4.5 flex flex-col gap-6 md:flex-row">
                                <div className="w-full md:w-1/2 mb-4">
                                    <Input
                                        label='Credencial'
                                        type='text'
                                        value={id ? formularioEditar.credential : formulario.credential}
                                        name='credential'
                                        placeholder='Ingrese la credencial'
                                        loading={loading}
                                        required={true}
                                        onChange={(e) => {
                                            id ? setFormularioEditar({ ...formularioEditar, credential: e.target.value })
                                                : setFormulario({ ...formulario, credential: e.target.value })
                                        }}
                                        alert={alert}
                                    />
                                </div>

                                <div className="w-full md:w-1/2">
                                    <Input
                                        label='Cargo'
                                        type='text'
                                        value={id ? formularioEditar.charge : formulario.charge}
                                        name='charge'
                                        placeholder='Cargo que desempeña'
                                        loading={loading}
                                        required={true}
                                        onChange={(e) => {
                                            id ? setFormularioEditar({ ...formularioEditar, charge: e.target.value })
                                                : setFormulario({ ...formulario, charge: e.target.value })
                                        }}
                                        alert={alert}
                                    />
                                </div>
                            </div>

                            {!id && <div className="mb-4.5 flex flex-col gap-6 md:flex-row">
                                <div className="w-full md:w-1/2 mb-4">
                                    <Input
                                        label='Contraseña'
                                        type='password'
                                        value={formulario.password}
                                        name='password'
                                        placeholder='Ingrese la contraseña'
                                        loading={loading}
                                        required={true}
                                        onChange={(e) => { setFormulario({ ...formulario, password: e.target.value }) }}
                                        alert={alert}
                                    />
                                </div>

                                <div className="w-full md:w-1/2">
                                    <Input
                                        label='Confirmar contraseña'
                                        type='password'
                                        value={formulario.password_confirmation}
                                        name='password_confirmation'
                                        placeholder='Confirme la contraseña'
                                        loading={loading}
                                        required={true}
                                        onChange={(e) => { setFormulario({ ...formulario, password_confirmation: e.target.value }) }}
                                        alert={alert}
                                    />
                                </div>
                            </div>}

                            <div className="mb-4.5 flex flex-row gap-6">
                                {/* <div className="w-full md:w-1/2">
                                        <div className="flex justify-center items-center">
                                            { (fileName === null) && (
                                                <img
                                                    src={ UserAvatar }
                                                    className="w-40 h-40 object-cover rounded-full bg-slate-200 border-4 border-turquesa"
                                                    alt=""
                                                />
                                            ) }
                                            { (fileName !== null) && (
                                                <img
                                                    src={fileName}
                                                    className="w-40 h-40 object-cover rounded-full bg-slate-200 border-4 border-turquesa"
                                                    alt=""
                                                />
                                            ) }
                                        </div>
                                    </div> */}
                                <div className="w-full md:w-1/2">
                                    <label className="mb-2 block font-medium text-sm text-slate-700 dark:text-white">
                                        Fotografía
                                    </label>
                                    <InputFile
                                        label='Foto'
                                        value={formulario.photo}
                                        name='photo'
                                        placeholder='Ingrese la fotografía'
                                        loading={loading}
                                        required={true}
                                        fileName={fileName}
                                        onChange={(e) => {
                                            handleFile(e);
                                        }}
                                        alert={alert}
                                    />
                                    <FormError errors={alert} name={"photo"} />
                                </div>
                            </div>



                            {loading ? <Skeleton className="w-full rounded py-3 px-5 text-2xl flex " />
                                :
                                <button type='submit' className="flex w-full flex-col justify-center mt-4 rounded bg-turquesa p-3 font-medium text-white hover:bg-opacity-90">
                                    {id === undefined ? 'Agregar' : 'Actualizar'}&nbsp;empleado
                                </button>}
                        </div>
                    </form>
                </div>
            </div>
        </MainThemeLayout>
    );
};

export default AddEditEmployee;